import $ from "jquery";

// AUTO SPIN
export class AutoSpinCustomization {

    constructor() {
        let that = this
        this.interval = null

        // Auto spin instant update (checkbox)
        $('[name="variant[enable_auto_spin]"]').change(function () {
            if (this.checked || this.value === "true") {
                viewer().auto_spin(true)
                $('[name="variant[auto_spin_for]"]').trigger('change')
                that.updateAutoSpinResults()
            } else {
                viewer().auto_spin(false)
            }
        })

        // Auto spin instant update
        $('[name="variant[auto_spin]"]').change(function () {
            viewer().auto_spin_speed(parseFloat(this.value), false)
            that.updateAutoSpinResults()
        })

        // Auto spin for instant update
        $('[name="variant[auto_spin_for]"]').change(function () {
            viewer().auto_spin_count(parseFloat(this.value))
            that.updateAutoSpinResults()
        })

        // Ease in instant update
        const easeIn = $('[name="variant[auto_spin_ease_in]"]')
        const easeInSlider = $('#auto_spin_ease_in_slider')

        easeIn.on('input', function () {
            viewer().auto_spin_ease_in(parseFloat(this.value))
            easeInSlider.val(this.value)
            that.updateAutoSpinResults()
        })

        easeInSlider.on('input', function () {
            easeIn.val(this.value)
            viewer().auto_spin_ease_in(parseFloat(this.value))
            that.updateAutoSpinResults()
        })

        // Ease out instant update
        const easeOut = $('[name="variant[auto_spin_ease_out]"]')
        const easeOutSlider = $('#auto_spin_ease_out_slider')

        easeOut.on('input', function () {
            viewer().auto_spin_ease_out(parseFloat(this.value))
            easeOutSlider.val(this.value)
            that.updateAutoSpinResults()
        })

        easeOutSlider.on('input', function () {
            easeOut.val(this.value)
            viewer().auto_spin_ease_out(parseFloat(this.value))
            that.updateAutoSpinResults()
        })

        // Ease intensity instant update
        const intensity = $('[name="variant[auto_spin_ease_intensity]"]')
        const intensitySlider = $('#auto_spin_ease_intensity_slider')

        intensity.on('input', function () {
            viewer().auto_spin_ease_intensity(parseFloat(this.value))
            intensitySlider.val(this.value)
            that.updateAutoSpinResults()
        })

        intensitySlider.on('input', function () {
            intensity.val(this.value)
            viewer().auto_spin_ease_intensity(parseFloat(this.value))
            that.updateAutoSpinResults()
        })
    }

    // Updates the auto spin results info
    updateAutoSpinResults() {
        let result = $('#auto_spin_ease_result')

        if (result.length === 0) {
            return
        }

        if (this.interval) {
            clearInterval(this.interval)
        }

        result.show()

        let curve = $('#auto_spin_ease_curve')
        let width = curve.width()
        curve.height(width)
        curve.attr('width', width)
        curve.attr('height', width)

        const canvas = curve[0]
        const ctx = canvas.getContext('2d')

        ctx.clearRect(0, 0, canvas.width, canvas.height)

        const max_index = canvas.width

        const points = []

        // Reset path
        ctx.beginPath()
        ctx.moveTo(0, 0)

        // Collect curve points
        let x, y, asc, end
        for (x = 0, end = max_index, asc = 0 <= end; asc ? x <= end : x >= end; asc ? x++ : x--) {
            y = viewer().settings.auto_spin_ease_curve(x / max_index) * max_index
            points.push({x, y: canvas.height - y})
            ctx.lineTo(x, canvas.height - y)
        }

        // Set color
        ctx.strokeStyle = "#ccc"

        // Draw curve
        ctx.stroke()

        // Reset path
        ctx.beginPath()
        ctx.moveTo(0, canvas.height)

        // Set color
        ctx.strokeStyle = "#117cd7"

        const max_frame = Math.min(viewer().settings.auto_spin_count, 500) * viewer().settings.per_row

        let that = this

        this.interval = setInterval(function () {
            const i = Math.abs(viewer().index - viewer().settings.key_image) / Math.abs(max_frame)
            const p = Math.round(i * canvas.width)

            ctx.lineTo(points[p].x, points[p].y)

            // Draw curve
            ctx.stroke()

            if (Math.round(Math.abs(viewer().index)) >= max_frame) {
                clearInterval(that.interval)
            }
        })
    }
}